import instance, { post } from "../../utils/BaseService";

export interface SignUpProps {
    tenancyName: string;
    name: string;
    email: string;
    surname: string;
    password: string;
    userName: string;
    phoneNumber: string;
}

export async function forgotPasswordSendMail(input: any): Promise<any> {
    return await instance.post('/Authentication/forgotPasswordSendMail', input);
};

export async function resetPassword(input: any): Promise<any> {
    return await instance.post('/Authentication/resetPassword', input);
};

export async function signUp(input: SignUpProps): Promise<any> {
    return await instance.post('/Authentication/signUp', input);
};